
















































































    
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { Address, AddressCreate, Client, ClientAddresses, ClientAddressService, ClientService } from '../../services/accounting.service';
import { HashMap } from '../../services/base.service';
import AddressDisplay from './../ui/AddressDisplay.vue'
import AddressForm from './AddressForm.vue'

@Component({
    components: {
        AddressDisplay,
        AddressForm,
    }
})
export default class ClientAddressesForm extends Vue {
    @Prop()
    public client!: Client;

    private clientApi: ClientService = new ClientService();
    private api: ClientAddressService = new ClientAddressService('');

    private addresses: Address[] = [];

    private loading: boolean = false;

    private billingAddressId?: string;
    private shippingAddressSame: boolean = false;
    private shippingAddressId?: string;

    private initialized = false;


    private editing: {[key: string]: AddressCreate} = {};

    async created() {
        
    }

    @Watch('client')
    public async clientChange() {
        if (this.client) {
            this.api = new ClientAddressService(this.client.id);
            if (this.client.billingAddress) {
                this.billingAddressId = this.client.billingAddress.id;
            }

            if (this.client.shippingAddress) {
                if (this.client.billingAddress && this.client.billingAddress.id === this.client.shippingAddress.id) {
                    this.shippingAddressSame = true;
                    this.shippingAddressId = this.client.billingAddress.id;
                } else {
                    this.shippingAddressId = this.client.shippingAddress.id;
                }
            }
            this.initialized = true;
            await this.refresh();
        } else {
            this.addresses = [];
        }
    }

    async refresh() {
        const res = await this.api.get();
        if (res.success) {
            this.addresses = res.result;
        }
    }

    async newAddress() {
        await this.refresh();
    }

    public updateShipping() {

    }

    edit(address: Address) {
        this.editing[address.id] = {...address};
        this.$forceUpdate();
    }

    cancelEdit(address: Address) {
        delete this.editing[address.id];
        this.$forceUpdate();
    }

    async remove(address: Address) {
        await this.api.delete(address.id);
        await this.refresh();
        this.$emit('update');
    }

    async addressUpdate(address: Address) {
        await this.refresh();
        this.cancelEdit(address);
        this.$emit('update');
    }

    async submit() {
        this.loading = true;

        const request = {
            billingAddressId: this.billingAddressId,
            shippingAddressSameAsBilling: this.shippingAddressSame,
            shippingAddressId: this.shippingAddressSame ? void 0 : this.shippingAddressId,
        };

        const res = await this.clientApi.setActiveAddresses(this.client.id, request);

        if (res.success) {
            this.client = res.result;
            await this.refresh();
            this.$emit('update');
        }

        this.loading = false;
    }
}

